import { getCurrentNetworkEnv, type NetworkEnvironment } from '@/hooks/useNetworkEnvironment'
export interface ApiConfig {
  apiRootUrl: string
  apiVersion: string
  apiBaseUrl: string
}

export const resolveApiConfig = (): ApiConfig => {
  const rawBaseUrl = (import.meta as any).env?.VITE_API_BASE_URL as string | undefined
  if (!rawBaseUrl || rawBaseUrl.trim().length === 0) {
    throw new Error('VITE_API_BASE_URL environment variable is required')
  }

  const rawVersion = (import.meta as any).env?.VITE_API_VERSION as string | undefined
  if (!rawVersion || rawVersion.trim().length === 0) {
    throw new Error('VITE_API_VERSION environment variable is required')
  }

  const trimmedBase = rawBaseUrl.trim().replace(/\/+$/, '')
  const apiRootUrl = trimmedBase.replace(/\/api(?:\/v?\d+)?$/i, '')

  const trimmedVersion = rawVersion.trim()
  const normalizedVersion = trimmedVersion.startsWith('v')
    ? trimmedVersion
    : `v${trimmedVersion}`

  return {
    apiRootUrl,
    apiVersion: normalizedVersion,
    apiBaseUrl: `${apiRootUrl}/api/${normalizedVersion}`,
  }
}

export const getApiBaseUrl = (): string => resolveApiConfig().apiBaseUrl
export const getApiRootUrl = (): string => resolveApiConfig().apiRootUrl
export const getApiVersion = (): string => resolveApiConfig().apiVersion

const normalizeHeaderValue = (value: string | undefined | null): string | null => {
  if (!value) {
    return null
  }
  const normalized = value.trim().toLowerCase()
  return normalized.length > 0 ? normalized : null
}

export const getApiClientHeaderForMode = (mode: NetworkEnvironment): string => {
  if (mode === 'testnet') {
    const testnetHeader = normalizeHeaderValue(
      (import.meta as any).env?.VITE_API_CLIENT_TESTNET as string | undefined
    )
    if (!testnetHeader) {
      throw new Error('VITE_API_CLIENT_TESTNET environment variable is required')
    }
    return testnetHeader
  }

  const mainnetHeader = normalizeHeaderValue(
    (import.meta as any).env?.VITE_API_CLIENT as string | undefined
  )
  if (!mainnetHeader) {
    throw new Error('VITE_API_CLIENT environment variable is required')
  }
  return mainnetHeader
}

export const getApiClientHeader = (): string =>
  getApiClientHeaderForMode(getCurrentNetworkEnv())
